import React from 'react';
import './AccountSummary.css';

interface AccountSummaryProps {
  className?: string;
}

export const AccountSummary: React.FC<AccountSummaryProps> = ({ className }) => {
  return (
    <section className={`account-summary ${className || ''}`}>
      <div className="summary-header">
        <h1 className="summary-title">Account Overview</h1>
        <div className="account-number-display">Account: MT12345678</div>
      </div>

      <div className="balance-display">
        <div className="balance-label">Available Balance</div>
        <div className="balance-amount">5,250.00</div>
        <div className="balance-currency">USD</div>
      </div>

      <div className="account-status">
        <div className="status-dot"></div>
        <span className="status-text">Active</span>
      </div>

      <div className="account-details">
        <div className="detail-row">
          <span className="detail-label">Account Type</span>
          <span className="detail-value">Standard</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Trading Group</span>
          <span className="detail-value">Default Options</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Base Currency</span>
          <span className="detail-value">USD</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Account Created</span>
          <span className="detail-value">Nov 15, 2024</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Last Login</span>
          <span className="detail-value">Today, 14:32</span>
        </div>
      </div>
    </section>
  );
};
